<template>
	<div class="main-betslip">
		<!-- Navigation -->
		<div class="main-betslip__nav">
			<div
				class="main-betslip__nav__item"
				@click="filter('betslip')"
				:class="{ 'main-betslip__nav__item--active': selected == 'betslip' }"
			>
				{{ $t("betslip.normal") }} ({{ mainBetslipCount }})
			</div>
			<div
				v-if="env.availableProducts.shikisha"
				class="main-betslip__nav__item"
				@click="filter('shikisha')"
				:class="{ 'main-betslip__nav__item--active': selected == 'shikisha' }"
			>
				{{ env.shikishaProductName }} ({{ shikishaBetslipCount }})
			</div>
			<div
				v-if="
					env.availableProducts.virtuals ||
					env.availableProducts.virtualHub
				"
				class="main-betslip__nav__item"
				@click="filter('virtual')"
				:class="{ 'main-betslip__nav__item--active': selected == 'virtual' }"
			>
				{{ $t("nav.virtual") + "s" }} ({{ virtualBetslipCount }})
			</div>
		</div>

		<!-- Settings -->
		<div
			class="main-betslip__header"
			v-if="
				(selected == 'betslip' && mainBetslipCount > 0) ||
				(selected == 'shikisha' && shikishaBetslipCount > 0) ||
				(selected == 'virtual' && virtualBetslipCount > 0)
			"
		>
			<div class="main-betslip__header__keep">
				<button class="button icon no-bg" @click="clear">
					<span class="button__title">{{ $t("betslip.remove-all") }}</span>
				</button>
				<div class="input-group-inline">
					<span
						class="input-group-inline__title"
						:class="{ disabled: areThereliveMatches }"
						>{{ $t("betslip.keep") }}</span
					>
					<div
						class="input-group-inline__checkbox"
						:class="{
							'input-group-inline__checkbox--active': keep,
						}"
						@click="keep = !areThereliveMatches && !keep"
					>
						<input
							class="input-group-inline__checkbox__input"
							:disabled="areThereliveMatches"
							type="checkbox"
							v-model="keep"
						/>
						<label
							class="input-group-inline__checkbox__label"
							:class="{
								'input-group-inline__checkbox__label--active': keep,
							}"
						/>
						<svg
							width="12"
							height="10"
							viewBox="0 0 12 10"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							v-show="keep"
						>
							<path
								d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z"
							></path>
						</svg>
					</div>
				</div>
			</div>
		</div>

		<shikisha-bet-betslip
			:keep="keep"
			v-if="selected == 'shikisha'"
			ref="shikisha"
		/>
		<virtual-betslip
			:keep="keep"
			v-else-if="selected == 'virtual'"
			ref="virtual"
		/>
		<betslip v-else :keep="keep" ref="betslip" />
	</div>
</template>
<script>
import Betslip from "./Betslip.vue";
import ShikishaBetBetslip from "./ShikishaBetBetslip.vue";
import VirtualBetslip from "./VirtualBetslip.vue";

export default {
	name: "main-betslip",
	components: {
		Betslip,
		ShikishaBetBetslip,
		VirtualBetslip,
	},
	data() {
		return {
			selected: "betslip",
			keep: false,
			refreshing: false,
			shikishaBaseRoute: "shikisha",
		};
	},
	mounted() {
		this.shikishaBaseRoute = this.env.shikishaProductName
			.replace(/\s/gi, "-")
			.toLowerCase();

		this.changeSelectedBetslip(this.$route);
	},
	watch: {
		$route(n, o) {
			this.changeSelectedBetslip(n);
		},
	},
	computed: {
		normalBets() {
			return this.$store.state.betSlip;
		},
		areThereliveMatches() {
			return (
				this.normalBets.filter((bet) => {
					return bet.live;
				}).length > 0
			);
		},
		mainBetslipCount() {
			return this.$store.getters.betSlipCount;
		},
		shikishaBetslipCount() {
			return this.$store.getters.jengabetBetSlipCount;
		},
		virtualBetslipCount() {
			return this.$store.getters.virtualBetslipCount;
		},
		betSlip() {
			return this.$store.getters.betSlip;
		},
	},
	beforeMount() {
		if (this.$route.query.type == "shikisha") this.filter("shikisha");
		if (this.$route.query.type == "virtual") this.filter("virtual");
		this.getUserDetails();
	},
	methods: {
		changeSelectedBetslip(route) {
			if (
				route.name !== undefined &&
				route.name.indexOf(this.shikishaBaseRoute) > -1
			)
				this.selected = "shikisha";
			if (route.name !== undefined && route.name.indexOf("virtual") > -1)
				this.selected = "virtual";
			if (
				[
					"home",
					"search",
					"sport",
					"sport-countries",
					"sport-competition",
					"prebet-markets",
					"live",
					"live-sport",
					"live-markets",
					"livescore",
				].includes(route.name)
			)
				this.selected = "betslip";
		},
		filter(selection) {
			this.selected = selection;
			this.$route.query.type = "shikisha";
		},
		getUserDetails() {
			let vm = this;
			if (!vm.$auth.getAuthStatus()) return;
			vm.$axios
				.post(`${BASE_URL}balance`, {
					token: window.localStorage.getItem("token")
						? JSON.parse(window.localStorage.getItem("token"))
						: "",
				})
				.then((response) => {
					vm.$store.commit("setBalance", response.data.data.balance);
					vm.$store.commit("setKyc", response.data.data.has_kyc);
					vm.refreshing = false;
				})
				.catch((error) => {
					console.error("Couldnt get balance", error);
				});
		},
		clear() {
			this.$refs[this.selected].clearBetslip();
		},
	},
};
</script>
<style lang="scss">
.main-betslip {
	margin-top: var(--margin-top-without-nav);
	background-color: var(--white);

	@media (min-width: 1023px) {
		min-height: calc(100vh - var(--desktop-header-offset));
		margin-top: 0;
		position: sticky;
		top: calc(2px + var(--desktop-header-offset));
		padding-bottom: 15px;
	}
	.rounded-card {
		margin: 0 10px 10px;
		// height: calc(100vh - 100px);
		// overflow-y: scroll;
	}
	&.hidden {
		display: none;
	}
	&__nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0 10px;
		border-bottom: 1px solid var(--line-11);
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		color: var(--line-11-dark);

		&__item {
			position: relative;
			background: var(--white);
			flex: 1;
			padding: 10px 0px;
			text-align: center;
			z-index: 1000;
			cursor: pointer;
			color: var(--active-state);
			&--active {
				border-bottom-color: var(--green);
				color: var(--green);
				&::after {
					content: "";
					position: absolute;
					display: block;
					width: 100%;
					height: 4px;
					left: 50%;
					transform: translate(-50%, 0%);
					border-radius: 4px 4px 0px 0px;
					background: var(--green);
					bottom: 0;
				}
			}
		}
	}
	&__header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 10px 25px;

		&__back {
			flex: 1;
			z-index: 1000;
		}
		&__title {
			text-transform: uppercase;
			font-weight: var(--font-weight-medium);
		}
		&__keep {
			flex: 1;
			text-align: right;
			z-index: 1000;
			display: inline-flex;
			justify-content: space-between;
			font-weight: var(--font-weight-lighter);
			.input-group-inline {
				margin: 0;
			}
		}
		.input-group__title {
			font-weight: var(--font-weight-lighter);
			font-size: var(--font-medium);
			color: var(--line-11-dark);
		}
		.button__title {
			font-weight: var(--font-weight-lighter);
			font-size: var(--font-medium);
			color: var(--green);
			margin: 0;
		}
		path {
			fill: var(--black);
		}
		button {
			padding: 0;
		}
	}
	.betslip {
		position: relative;
	}
	.betslip-content {
		// padding-bottom: 360px;
		background-color: var(--white);

		@media (min-width: 1023px) {
			overflow: auto;
			padding-bottom: 0;
			height: 34.7vh;
		}
		&--empty {
			width: 80%;
			margin: 5px auto;
			padding: 10px 10px;
			text-align: center;
			color: var(--light-black);
			font-size: var(--font-medium);
		}
	}

	.delete-all {
		text-align: center;
		color: #c00;
		text-transform: uppercase;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-small);
		padding: 10px;
		vertical-align: top;
		border: none;
		background: transparent;
		margin: auto;
		margin-bottom: 300px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
}
.betslip__details {
	background-color: var(--white);
	font-size: var(--font-small);
	color: var(--black);
	width: 100%;
	max-width: var(--app-width);
	padding-bottom: 15px;

	@media (max-width: 1023px) {
		// position: fixed;
		// bottom: 55px;
		// z-index: 999;
		// padding-bottom: 70px;
	}

	&__container {
		padding-top: 20px;
	}
	&__buttons {
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		padding: 0 10px;

		&__place {
			border-top-right-radius: 5px;
		}

		.share-betslip {
			margin-right: 10px;
			button {
				background-color: var(--line-11-dark);
			}
		}
	}
	&__row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0px 10px 10px 10px;
		// @media (min-width: 999px) {
		// 	padding: 0px 10px 8px 10px;
		// }
		align-items: center;
		&__column {
			display: flex;
			flex-direction: column;

			&__bottom {
				display: flex;
				align-items: center;
				margin-top: 6px;
			}
			&__icon {
				fill: var(--black);
			}
			&__text {
				margin: 0 5px;
				color: var(--black);
				font-size: var(--font-normal);
				font-weight: var(--font-weight-lighter);
				// @media (min-width: 999px) {
				// 	font-size: var(--font-normal);
				// }
			}
		}
		&__remove {
			color: var(--red);
			cursor: pointer;
			text-align: right;
		}
		&__label {
			flex-basis: 60%;
			position: relative;
			display: flex;
			flex-direction: row;
			align-items: center;
			font-size: var(--font-normal);
			// @media (min-width: 999px) {
			// 	font-size: var(--font-normal);
			// }
			font-weight: var(--font-weight-lighter);
			color: var(--non-active-state);

			&__offersvg {
				width: 18px;
				height: 18px;
				// @media (min-width: 999px) {
				// 	width:18px;
				// 	height:18px;
				// }
			}
		}
		&__value {
			flex-basis: 40%;
			text-align: right;
			font-size: var(--font-normal);
			// @media (min-width: 999px) {
			// 	font-size: var(--font-normal);
			// }
			font-weight: var(--font-weight-medium);
			padding-bottom: 0 !important;
			.input__desc {
				padding: 0;
			}
			input {
				text-align: right;
				background: var(--black-light-10);
				border-radius: 4px;
				width: calc(100% - 21px);
				border: 1px solid transparent;
				&:focus {
					border-color: var(--line-11);
				}
				&::-webkit-input-placeholder {
					font-size: var(--font-normal);
					font-weight: var(--font-weight-lighter);
				}
				&:-moz-placeholder {
					font-size: var(--font-normal);
					font-weight: var(--font-weight-lighter);
				}
				&::-moz-placeholder {
					font-size: var(--font-normal);
					font-weight: var(--font-weight-lighter);
				}
				&:-ms-input-placeholder {
					font-size: var(--font-normal);
					font-weight: var(--font-weight-lighter);
				}
			}
			&__award {
				color: var(--yellow);
				background-color: var(--light-yellow);
				padding: 9px;
				margin: 0px 10px 0px 0px;
				border-radius: 4px;
				border: 0;
				width: 50px;

				&__icon {
					width: 22px;
					height: 22px;
				}
				&__count {
					display: block;
					background-color: var(--yellow);
					color: var(--always-black);
					border-radius: 50%;
					font-size: var(--font-tiny);
					height: 8px;
					width: 8px;
					line-height: 12px;
					position: relative;
					top: -1px;
					right: -22px;
					margin-bottom: -10px;
				}
			}
		}
	}
}

.betslip__bet {
	background: var(--white);
	font-size: var(--font-small);
	color: var(--black);
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
	padding-left: 20px;
	&__group {
		background: var(--white);
		padding: 0 5px;
		padding-right: 12px;
		&__top {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding: 10px 0;
			&__title {
				font-size: var(--font-medium);
			}
			&__remove {
				background: var(--black);
				color: var(--white);
				border: none;
			}
		}
		&__bottom {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding: 10px 0;
			padding-right: 12px;
		}
	}
	&--expired {
		background: var(--light-red) !important;
		color: var(--always-black) !important;
		.betslip__bet__link {
			color: var(--always-black) !important;
		}
		.betslip__bet__market {
			color: var(--always-black) !important;
		}
	}
	&--inactive {
		background: var(--light-red) !important;
		color: var(--always-black) !important;
		.betslip__bet__link {
			color: var(--always-black) !important;
		}
		.betslip__bet__market {
			color: var(--always-black) !important;
		}
	}
	&__live {
		color: var(--red);
		font-weight: var(--font-weight-medium);
	}
	&__remove {
		width: 20px;
		font-size: var(--font-small);
		border: none;
		padding: 10px 0 0 5px;
		margin: 0;
		background: transparent;
		color: var(--active-state);
		vertical-align: middle;
		position: absolute;
		top: 0;
		left: 0;
	}
	&__details {
		flex: 1;
		padding: 5px 0;
	}
	&__odd {
		padding: 0 5px;
		&__value {
			&.expired {
				color: var(--red);
			}
		}
	}
	&__market {
		color: var(--light-black);
	}
	&__row {
		padding: 5px 12px 0 5px;
		&--top {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
		&--middle {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			font-weight: var(--font-weight-medium);
		}

		&--bottom {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
	}
	&__marker {
		background: #d8d8d8;
		color: var(--black);
		padding: 2px 4px;
		margin-right: 2px;
		font-size: var(--font-smallest);
		border-radius: 2px;
		display: inline-block;
		&--starttime {
			background: var(--light-gray);
		}
		&--changed {
			background: var(--yellow) 3d;
			color: #796702;
		}
		&--expired {
			background: #ffdada;
			color: #b90000;
		}
	}

	&__link {
		text-decoration: none;
		font-size: var(--font-small);
		color: var(--dark-blue);
	}
}
</style>